import { Button } from "antd"
import React from "react"
import { PROCESS_ENV } from "~Shared/config/env.utils"
import { useLoggedInEmployeeProfile } from "~Shared/hooks/user.hooks"
import { useBillingSettings } from "~Shared/queries/billing.queries"
import { isDeployEnvInternal, isNodeEnvDev } from "~Shared/utils/helper.utils"

export const BillingStripeButton = () => {
    const loggedInUser = useLoggedInEmployeeProfile()

    const isTest = isNodeEnvDev || isDeployEnvInternal
    const isForbidden = !isTest && loggedInUser.email !== PROCESS_ENV.FINWAY_ADMIN_EMAIL

    const { data: billingSettings } = useBillingSettings({ isEnabled: !isForbidden })

    const isUnavailable = !billingSettings?.customerId

    if (isForbidden || isUnavailable) {
        return null
    }

    return (
        <a target="_blank" href={`https://dashboard.stripe.com/${isTest ? "test/" : ""}customers/${billingSettings.customerId}`} rel="noreferrer">
            <Button>View Customer On Stripe</Button>
        </a>
    )
}
